import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { enabledSelector, labelSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import SignatureInput from '../../common/controls/signatureInput';
import signatureHandling from '../../common/controls/signatureHandling';
import uploadUtils from '../../../utils/uploadUtils';
const SignatureModal = _ref => {
  let enabled = _ref.enabled,
    onChange = _ref.onChange,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    onHide = _ref.onHide,
    notificationActions = _ref.notificationActions,
    _ref$user = _ref.user,
    user = _ref$user === void 0 ? null : _ref$user;
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    signature = _useState2[0],
    setSignature = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSaving = _useState4[0],
    setIsSaving = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoadingSaved = _useState6[0],
    setIsLoadingSaved = _useState6[1];
  const handleSignatureUpdate = (signatureBlob, signatureHash) => setSignature(signatureBlob ? {
    signatureBlob,
    signatureHash
  } : {});
  const signatureBlob = signature.signatureBlob,
    signatureHash = signature.signatureHash;
  const handleClose = () => {
    // clear signature data when hiding using add or cancel modal
    setSignature({});
    onHide();
  };
  const handleSave = async () => {
    setIsSaving(true);
    if (signatureBlob) {
      const result = await signatureHandling.uploadSignature(signatureHash, signatureBlob);
      if (typeof result === 'string') {
        notificationActions.error({
          message: result
        });
        onChange(null);
      } else {
        onChange(result);
      }
    } else {
      onChange(null);
    }
    setIsSaving(false);
    handleClose();
  };
  const handleUseSavedSignature = async () => {
    if (!(user !== null && user !== void 0 && user.signaturePath)) {
      notificationActions.error({
        message: 'No saved signature found.'
      });
      return;
    }
    setIsLoadingSaved(true);
    try {
      const cachedUrl = await uploadUtils.getS3DownloadUrl(user.signaturePath);
      const result = {
        fileName: user.signaturePath,
        cachedUrl
      };
      onChange(result);
      handleClose();
    } catch (error) {
      notificationActions.error({
        message: 'There was a problem loading the saved signature.'
      });
    } finally {
      setIsLoadingSaved(false);
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: onHide,
    backdrop: "static",
    style: {
      minWidth: '691px'
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, null, "Signature"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, (user === null || user === void 0 ? void 0 : user.signaturePath) && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '15px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "t-sm-use-saved",
    className: "t-sm-use-saved",
    onClick: handleUseSavedSignature,
    disabled: !enabled || isSaving || isLoadingSaved,
    color: "secondary",
    block: true
  }, isLoadingSaved ? 'Loading...' : 'Use Saved Signature')), /*#__PURE__*/React.createElement(SignatureInput, {
    handleSignatureData: handleSignatureUpdate,
    disabled: !enabled || isSaving || isLoadingSaved
  })))), /*#__PURE__*/React.createElement(ModalFooter, null, isSaving || isLoadingSaved ? /*#__PURE__*/React.createElement("div", {
    className: "miniLoader float-right",
    style: {
      marginLeft: 5
    }
  }) : null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "t-sm-add",
    className: "t-sm-add",
    onClick: handleSave,
    disabled: isSaving || isLoadingSaved
  }, "Add"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "t-sm-cancel",
    className: "t-sm-cancel",
    onClick: handleClose,
    disabled: isSaving || isLoadingSaved
  }, "Cancel")));
};
SignatureModal.propTypes = {
  enabled: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  user: PropTypes.shape({
    signaturePath: PropTypes.string
  })
};
export { SignatureModal as UncomposedSignatureModal };
export default entityComposition(SignatureModal, [], {
  enabled: enabledSelector,
  label: labelSelector,
  user: state => {
    var _state$login;
    return (_state$login = state.login) === null || _state$login === void 0 ? void 0 : _state$login.user;
  }
}, ['notification']);